import { createContext, useContext, useState, useCallback, useEffect } from "react";
import translations from "../i18n/translations";
import extraStrings from "../i18n/extraStrings";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LanguageContext = createContext();

// The main table with the later additions laid over it. Anyone following a key
// that is not in translations.js will find it in extraStrings.js, and a key
// present in both takes the value from extraStrings, which is how a wrong
// string gets corrected without rewriting the large file around it.
const STRINGS = {
  en: { ...translations.en, ...extraStrings.en },
  it: { ...translations.it, ...extraStrings.it },
};

export function LanguageProvider({ children, initialLang }) {
  const [language, setLanguageState] = useState(initialLang || "en");

  useEffect(() => {
    if (initialLang && initialLang !== language) setLanguageState(initialLang);
  }, [initialLang]);

  const t = useCallback(
    (key, params) => {
      let str = STRINGS[language]?.[key] || STRINGS["en"]?.[key] || key;
      if (params) {
        Object.entries(params).forEach(([k, v]) => {
          str = str.replace(`{${k}}`, v);
        });
      }
      return str;
    },
    [language]
  );

  const setLanguage = useCallback(async (lang) => {
    setLanguageState(lang);
    try {
      await axios.patch(`${API}/auth/language`, { language: lang }, { withCredentials: true });
    } catch {
      // Still update locally even if API fails
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
